// extracted by mini-css-extract-plugin
module.exports = {"container":"FlagWithLocale_container__UVMQB","flag":"FlagWithLocale_flag__6kgCD","selected":"FlagWithLocale_selected__yTcB5","label":"FlagWithLocale_label__3dqns"};